<script lang="ts">
  import Container from "./Container.svelte";
</script>

<Container margin="m" justify="center" {...$$props}>
  <slot />
</Container>
